var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgFormsBuilder = function SvgFormsBuilder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 1.499h15v15h-15v-15zM13.5 4.499h-3M13.5 7.499h-4M13.5 10.499h-4M12.5 13.499h-3",
    stroke: "#5F6771",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 4.499h3v3h-3v-3zM4.5 10.499h3v3h-3v-3z",
    stroke: "#5F6771",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgFormsBuilder;